import axiosApi from "../../components/Api/Axios";
import Office from "../../Models/Office/Office";
import BackendServices from "../../components/Api/BackendService";
import { office } from "../../components/Paths/paths";

export default (id: string | number) =>
  axiosApi.get<Office>(
    `${BackendServices.CERTIFICATION_SERVICE.CERTIFICATION_BODY}${office}/${id}`
  );
